import { Outlet, useNavigate } from 'react-router-dom';
import { useState, useEffect } from 'react';
import TopBar from '../components/TopBar';
import Sidebar from '../components/Sidebar';
import { AdminDataProvider } from '../contexts/AdminDataContext';
import '../styles/responsive.css';

function AdminLayout({ onLogout }) {
  const navigate = useNavigate();
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  // Check if screen is mobile size
  useEffect(() => {
    const checkScreenSize = () => {
      setIsMobile(window.innerWidth <= 768);
      if (window.innerWidth > 768) {
        setIsSidebarOpen(false);
      }
    };

    checkScreenSize();
    window.addEventListener('resize', checkScreenSize);
    return () => window.removeEventListener('resize', checkScreenSize);
  }, []);

  const handleLogout = () => {
    if (onLogout) {
      onLogout();
    } else {
      navigate('/login');
    }
  };

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  const closeSidebar = () => {
    setIsSidebarOpen(false);
  };

  return (
    <AdminDataProvider>
      <div className="dashboard-wrapper">
        <TopBar 
          username="Admin" 
          onLogout={handleLogout}
          onToggleSidebar={toggleSidebar}
          isMobile={isMobile}
        />
        <Sidebar 
          isOpen={isSidebarOpen} 
          onClose={closeSidebar}
          isMobile={isMobile}
        />
        <main className="main-content">
          <Outlet />
        </main>
      </div>
    </AdminDataProvider>
  );
}

export default AdminLayout;
